import BaseComponentController from "./base_component_controller"

export default class extends BaseComponentController {
  static targets = ['title', 'body', 'confirmButtonText', 'cancelButtonText']

  static values = {
    confirmTitle: { type: String },
    confirmMessage: { type: String },
    cancelButtonTitle: { type: String },
    confirmButtonTitle: { type: String }
  }

  connect() {
    this.element.addEventListener('design-system--modal-component:after-close', () => setTimeout(() => this.resetContents(), 400))
  }

  show(event) {
    event?.preventDefault()
    this.titleTarget.innerHTML = event.detail.confirmTitle
    this.bodyTarget.innerHTML = event.detail.confirmMessage || ''

    if (this.bodyTarget.innerHTML.trim() === '') {
      this.bodyTarget.closest('.design-system-panel-body-component').classList.add('hidden')
    }

    this.confirmButtonTextTarget.innerHTML = event.detail.confirmButtonTitle || this.confirmButtonTitleValue
    this.cancelButtonTextTarget.innerHTML = event.detail.cancelButtonTitle || this.cancelButtonTitleValue

    this.dispatchEvent({ action: 'modal-toggle' })
  }

  confirm(event) {
    this.dispatchEvent({ action: 'modal-toggle' })
    this.dispatchEvent({ action: 'confirm'})
  }

  cancel(event) {
    this.dispatchEvent({ action: 'modal-toggle' })
    this.dispatchEvent({ action: 'cancel' })
  }

  resetContents() {
    this.titleTarget.innerHTML = this.confirmTitleValue
    this.bodyTarget.innerHTML = this.confirmMessageValue
    this.bodyTarget.closest('.design-system-panel-body-component').classList.remove('hidden')
    this.confirmButtonTextTarget.innerHTML = this.confirmButtonTitleValue
    this.cancelButtonTextTarget.innerHTML = this.cancelButtonTitleValue
  }
}

